var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row notes"},[_c('h4',[_vm._v(_vm._s(_vm.label))]),_vm._v(" "+_vm._s(_vm.notesText)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }